import { Box } from "@mui/material";
import ReactLoading from "react-loading";

interface LoadingSpinnerProps {
  fullScreen?: boolean;
  [key: string]: any;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ fullScreen = false, ...rest }) => {
  return (
    <Box
      sx={{
        ...(fullScreen
          ? {
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)", // Dimmed background
            zIndex: 1300, // Ensure it appears above all other content
          }
          : {}),
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      {...rest}
    >
      <ReactLoading type="bars" color="rgb(26, 144, 255)" />
    </Box>
  );
};

export default LoadingSpinner;
